/* eslint-disable import/no-dynamic-require */
import commonConfig from './common.json';

export default {
  // colors: colors.global,
  env: process.env.NODE_ENV,
  ...commonConfig,
};
